export default __webpack_public_path__ + "static/media/qrCode.740ef6a9.jpg";